const trim = (value: string): string => {
  if (!value) {
    return value;
  }

  return value.trim();
};

export default trim;
